// extracted by mini-css-extract-plugin
export default {"wrapper":"ReceiptUnconfirmed_wrapper__oHh-u","title":"ReceiptUnconfirmed_title__jD6uT","text":"ReceiptUnconfirmed_text__iGDuK"};